import { has } from 'lodash'
import errorMessages from '@/helpers/errorMessages.js'
import moment from 'moment'
import router from '@/router'
import config from '@/config'

const initialState = {
  apiCalls: [],
  callInProgress: false,
  xCsrfToken: '',
  errorCode: null,
  timeOfLastRequest: null,
  expirationPopup: null
}

export default {
  namespaced: true,
  state: Object.assign({}, initialState),
  getters: {
    getXCsrfToken(state) {
      return state.xCsrfToken
    },
    getTimerPopup(state) {
      return state.expirationPopup
    }
  },
  mutations: {
    resetStateData(state) {
      for (let prop in state) {
        state[prop] = initialState[prop]
      }
    },
    setXCsrfToken(state, token) {
      state.xCsrfToken = token
    },
    addCall(state, call) {
      state.apiCalls.push(call)
    },
    takeCall(state) {
      state.apiCalls.shift()
    },
    callInProgress(state, value) {
      state.callInProgress = value
    },
    setErrorCode(state, errorCode) {
      state.errorCode = errorCode
    },
    clearCalls(state) {
      state.apiCalls = []
    },
    setTimeOfLastRequest(state, time) {
      state.timeOfLastRequest = time
    },
    setExpirationPopup(state, expirationPopup) {
      state.expirationPopup = expirationPopup
    },
    clearExpirationPopup(state) {
      state.expirationPopup = clearTimeout(state.expirationPopup)
    }
  },
  actions: {
    resetStateData({ commit }) {
      commit('resetStateData')
      commit('clearExpirationPopup')
    },
    redirectTo(context, page) {
      router.push({ name: page })
    },
    redirectToPolling(context, id) {
      window.location = `${config.REDIRECT_URL}service/polling/index?id=${id}`
    },
    getXCsrfToken({ dispatch }) {
      dispatch('makeCall', {
        route: 'auth.index'
      })
    },
    setXCsrfToken({ commit }, token) {
      commit('setXCsrfToken', token)
    },
    takeCall({ commit }) {
      commit('takeCall')
      commit('callInProgress', false)
      return Promise.resolve(false)
    },
    startCall({ commit }) {
      commit('callInProgress', true)
      return Promise.resolve(true)
    },
    setExpirationPopup({ commit, dispatch, rootGetters }) {
      commit('clearExpirationPopup')
      if (rootGetters['user/isSignedIn']) {
        let timerId = setTimeout(function () {
          dispatch('popup/setCurrentPopup', 'sessionExpiration', { root: true })
        }, rootGetters['auth/sessionExpirationPopupTime'])
        commit('setExpirationPopup', timerId)
      }
    },
    clearExpirationPopup({ commit }) {
      commit('clearExpirationPopup')
    },
    makeCall({ dispatch, commit }, { route, payload }) {
      dispatch('setExpirationPopup', { root: true })
      commit('setTimeOfLastRequest', moment().format())
      return new Promise((resolve, reject) => {
        commit('addCall', {
          route,
          payload,
          resolve,
          reject
        })
      })
    },
    async onError({ dispatch, commit }, error) {
      const errorCode = has(error, 'response.status') ? error.response.status : null
      if (errorCode === 401) {
        dispatch('user/setUserData', {}, { root: true })
        await dispatch('redirectTo', 'login')
      } else if (errorMessages[errorCode]) {
        commit('setErrorCode', errorCode)
        await dispatch('redirectTo', 'error-page')
      }
    },
    clearApiCalls({ commit }) {
      commit('clearCalls')
      commit('callInProgress', false)
      return Promise.resolve(true)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js